import { useInvoices, useIsBillingEnabledOnHospital } from '@/modules/billing';
import { useEffect } from 'react';
import { useDialog } from '@ianesthesie-kit/redux';
import { useAppDispatch, useAppSelector } from '@/hooks';
import {
  selectIsUnsignedInvoicesCheckDone,
  setUnsignedInvoicesCheckDone
} from '@/modules/ui';
import { AppDialogType } from '@/config';
import { useHasPendingConsent } from '@/modules/informedConsent';
import { useIsVerified } from '@/modules/userConfig';
import { dialogsAllowedOnPage, selectIsAnyDialogOpen } from './util';

export const useDelayedInvoiceChecker = (opts?: { skip?: boolean }) => {
  const { showDialog } = useDialog();
  const dispatch = useAppDispatch();
  const isCheckDone = useAppSelector(selectIsUnsignedInvoicesCheckDone);
  const isAnyDialogOpen = useAppSelector(selectIsAnyDialogOpen);
  const billingEnabled = useIsBillingEnabledOnHospital();
  const isVerified = useIsVerified();
  const { hasPendingConsent, isLoadingConsent } = useHasPendingConsent({
    skip: opts?.skip
  });
  const skip =
    !!opts?.skip ||
    !isVerified ||
    !billingEnabled ||
    isCheckDone ||
    isLoadingConsent ||
    hasPendingConsent ||
    !dialogsAllowedOnPage();
  const { currentData: invoices, isLoading } = useInvoices(undefined, {
    skip
  });

  useEffect(() => {
    if (isLoading || skip || isAnyDialogOpen) {
      return;
    }
    const hasUnsigned = !!invoices?.find((inv) => !inv.signedByPatient);

    const t = setTimeout(() => {
      if (hasUnsigned) {
        showDialog({
          dialogType: AppDialogType.INVOICES,
          message: 'patient-app.invoicesDialog.message.new'
        });
      }
      dispatch(setUnsignedInvoicesCheckDone());
    }, 3500);

    return () => clearTimeout(t);
  }, [invoices, dispatch, isLoading, skip, showDialog, isAnyDialogOpen]);
};
